var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer container-fluid mt-auto text-center"},[_c('p',{staticStyle:{"color":"white"}},[_vm._v("© "+_vm._s(_vm.currDate)+" Phuykong Meng. Powered by Vue JS. Coded with ❤.")])])}
var staticRenderFns = []

export { render, staticRenderFns }